import { Star } from "lucide-react";

export const Stars = ({ value = 0, count, size = "h-4 w-4", onRate }) => (
  <div className="flex items-center gap-0.5" data-testid="stars">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        disabled={!onRate}
        onClick={() => onRate && onRate(n)}
        aria-label={`${n} stelle`}
        className={onRate ? "cursor-pointer transition-transform hover:scale-110" : "cursor-default"}
      >
        <Star className={`${size} ${n <= Math.round(value) ? "fill-amber text-amber" : "text-ink-soft/50"}`} strokeWidth={1.5} />
      </button>
    ))}
    {count != null && <span className="ml-1 text-xs text-ink-soft">{count > 0 ? `(${count})` : "Nessuna recensione"}</span>}
  </div>
);
